import React, { useEffect, useState } from 'react'
import useStore from '../../BusinessStore/Store'
import BasicInformation from './BasicInfo/BasicInfo'
import KeywordDescription from './Description/Description'
import KeywordFeature from './Keyword/KeywordFeature'
import Location from './Location/Location'
import PrimaryCategories from './PrimaryCategories/PrimaryCategoriesFilter'
import RawCategories from './RawCategories/RawCategories'
import RecordRecency from './RecordRecency/RecordRecency'
import RequiredFields from './RequiredFields/RequiredFields'
import { default as styles, default as stylesModal } from './styles.module.css'; // Assuming you have a CSS module with the required stylesModal
import RangeReviews from './Reviews/Reviews'
import  ReviewByDateComponent from './ReviewByDate/ReviewByDate'
import useEscapeKey from '../../../utils/useEscapeKey'

function ExpandedModal ({ onClose }) {
  const {
    isQueryLoading,
    name,
    setName,
    resetStore,
    city,
    setCity,
    address,
    setAddress,
    state,
    setState,
    postalCode,
    setPostalCode,
    country,
    setCountry,
    rawCategory,
    primaryCategories,
    setPrimaryCategories,
    setRawCategory,
    recordRecency,
    setRecordRecency,
    featureKeyword,
    setFeatureKeyword,
    description,
    setDescription,
    requiredFields,
    setRequiredFields,
    reviewsRangeQuery,
    setReviewsRangeQuery,
    reviewsByDate,
    setReviewsByDate
  } = useStore()
  const [isVisible, setIsVisible] = useState(false)
  const [localBasicInformation, setLocalBasicInformation] = useState(name)
  const [localCity, setLocalCity] = useState(city)

  const [localAddress, setLocalAddress] = useState(address)
  const [localState, setLocalState] = useState(state)
  const [localPostalCode, setLocalPostalCode] = useState(postalCode)
  const [localCountry, setLocalCountry] = useState(country)
  const [localRawCategory, setLocalRawCategory] = useState(rawCategory)
  const [localPrimaryCategory, setLocalPrimaryCategory] =
    useState(primaryCategories)
  const [localRecordRecency, setLocalRecordRecency] = useState(recordRecency)

  const [localFeatureKeyword, setLocalFeatureKeyword] = useState(featureKeyword)

  const [localDescription, setLocalDescription] = useState(description)

  const [localRequiredFields, setLocalRequiredFields] = useState(requiredFields)
  const [localReviewsRangeQuery, setLocalReviewsRangeQuery] = useState(reviewsRangeQuery)

  const [localReviewByDateQuery, setLocalReviewByDateQuery] = useState(reviewsByDate)

  // Function to handle backdrop click
  const handleBackdropClick = event => {
    // Check if the clicked element is the backdrop itself, not its children
    if (event.target === event.currentTarget) {
      setIsVisible(false)
      setTimeout(() => {
        onClose()
      }, 250)
    }
  }

  const handleClose = () => {
    // Start the slide-out effect
    setIsVisible(false)
    // Use a timeout to match the CSS transition duration
    setTimeout(() => {
      onClose()
    }, 250)
  }

  useEscapeKey(handleClose)

  useEffect(() => {
    // Trigger the slide-in effect when the component mounts
    const timeoutId = setTimeout(() => {
      setIsVisible(true)
    }, 1)

    return () => clearTimeout(timeoutId)
  }, [])

  useEffect(() => {
    if (isQueryLoading) {
      handleClose()
    }
  }, [isQueryLoading]) /* eslint-disable-line react-hooks/exhaustive-deps */

  const handleApplyFilters = () => {
    // Only proceed if not already loading
    if (!isQueryLoading) {
      // Update all filters, including price filter state
      setName(localBasicInformation)
      setAddress(localAddress)
      setCity(localCity)
      setState(localState)
      setPostalCode(localPostalCode)
      setCountry(localCountry)
      setPrimaryCategories(localPrimaryCategory)
      setRawCategory(localRawCategory)
      setRecordRecency(localRecordRecency)
      setFeatureKeyword(localFeatureKeyword)
      setDescription(localDescription)
      setRequiredFields(localRequiredFields)
      setReviewsRangeQuery(localReviewsRangeQuery);
      setReviewsByDate(localReviewByDateQuery);
      // close
      setIsVisible(false)
      setTimeout(() => {
        onClose()
      }, 250)
    }
  }

  const handleClearFilters = () => {
    // if (queryStore) {
    resetStore()
    // Reset the local states
    // setLocalBasicInformation('')
    handleClose()
    // }
  }

  return (
    <div className={stylesModal.modalBackdrop} onClick={handleBackdropClick}>
      <div
        className={stylesModal.modalContent}
        style={{ transform: isVisible ? 'translateX(0)' : 'translateX(100%)' }}
        onClick={e => e.stopPropagation()}
      >
        <div className={stylesModal.modalHeader}>
          <h2 className={styles.ApiCallTitle}>Filters</h2>
          <div className={styles.containerButtonsFilters}>
            <span
              className={styles.buttonClearFilter}
              onClick={handleClearFilters}
            >
              Clear filters
            </span>
            <button
              className={styles.buttonApplyFilters}
              onClick={handleApplyFilters}
            >
              Apply filters
            </button>
          </div>
        </div>
        <hr className={styles.hrExpandedModal} />
        <BasicInformation
          localBasicInformation={localBasicInformation}
          setLocalBasicInformation={setLocalBasicInformation}
        />
        <hr className={styles.hrExpandedModal} />

        <Location
          localAddress={localAddress}
          setLocalAddress={setLocalAddress}
          localCity={localCity}
          setLocalCity={setLocalCity}
          localState={localState}
          setLocalState={setLocalState}
          localPostalCode={localPostalCode}
          setLocalPostalCode={setLocalPostalCode}
          localCountry={localCountry}
          setLocalCountry={setLocalCountry}
        />
        <hr className={styles.hrExpandedModal} />
        <section style={{ marginTop: '22px', marginBottom: '24px' }}>
          <h1 className={styles.locationTitle}>Categories</h1>
          <div style={{ display: 'flex', flexDirection: 'row', gap: '40px' }}>
            <RawCategories
              localRawCategory={localRawCategory}
              setLocalRawCategory={setLocalRawCategory}
            />
            <PrimaryCategories
              localPrimaryCategory={localPrimaryCategory}
              setLocalPrimaryCategory={setLocalPrimaryCategory}
            />
          </div>
        </section>

        <hr className={styles.hrExpandedModal} />

        <RangeReviews localReviewsRangeQuery={localReviewsRangeQuery} setLocalReviewsRangeQuery={setLocalReviewsRangeQuery} />

        <ReviewByDateComponent localReviewByDateQuery={localReviewByDateQuery}  setLocalReviewByDateQuery = {setLocalReviewByDateQuery}/>
        
        <hr className={styles.hrExpandedModal} />

        <RecordRecency
          localRecordRecency={localRecordRecency}
          setLocalRecordRecency={setLocalRecordRecency}
        />

        <hr className={styles.hrExpandedModal} />

        <KeywordFeature localFeatureKeyword={localFeatureKeyword} setLocalFeatureKeyword={setLocalFeatureKeyword} />

        <KeywordDescription localDescription={localDescription} setLocalDescription={setLocalDescription} />
        
        <hr className={styles.hrExpandedModal} />

        <RequiredFields localRequiredFields={localRequiredFields} setLocalRequiredFields={setLocalRequiredFields} />

        <hr className={styles.hrExpandedModal} />
      </div>
    </div>
  )
}

export default ExpandedModal
